<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link current">パスワードを変更する</span>
              <span class="breadcrumb-link">パスワードを変更する（メール送信完了）</span>
            </div>
            <h1 class="hdg02">パスワードを変更する</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">パスワードを忘れた方は、ご登録されたメールアドレスを入力して、パスワードの再設定を行ってください。</p>
              <h2 class="hdg03">パスワード変更の手続きフォーム</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご登録されたメールアドレス <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="email" placeholder="yamada-taro@sn-hoki.co.jp" v-model="group1.email">
                          </div>
                          <p class="error-message" v-if="group1.error_email">{{group1.error_email}}</p>
                          <p class="txt">もう一度入力してください</p>
                          <div class="formparts text formparts-short">
                            <input type="email" placeholder="yamada-taro@sn-hoki.co.jp" v-model="group1.email_check">
                          </div>
                          <p class="error-message" v-if="group1.error_email_check">{{group1.error_email_check}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg04">個人情報の取り扱いについて</h2>
              <p class="txt">お客様の個人情報は、本人確認、お問い合わせ対応および各種ご案内の送付などの業務活動並びに当社の定める利用目的の範囲内で、当社の関連会社や協力会社に対して提供する場合があります。<br>本ページ記載事項（規約を含む）を必ずご確認いただきますようお願いいたします。本ページ記載事項（規約を含む）にご同意いただいた場合は、[同意した上で進む]ボタンをクリックして確認画面へお進みください。</p>
              <ul class="list-inline mt12">
                <li>
                  <a href="https://www.sn-hoki.co.jp/guide/social_rules/" class="txt-blue" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
                <li>
                  <a href="https://www.sn-hoki.co.jp/privacy/" class="txt-blue" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
              </ul>
              
              <div class="contact-submit">
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.submitButtonClicked">同意した上で進む</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

import * as logicPasswordReminder from '@/logic/public/PasswordReminder.js'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    const group1 = logicPasswordReminder.getEmailInput()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
@media screen and (min-width:$width-container + 1) {
  .formparts-short{
    width: 60%;
  }
}
</style>
